import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { MedicalGuide } from 'src/app/shared/models/api';
import { AppState, Province } from 'src/app/shared/models/state';
import { ApiService } from 'src/app/shared/services/api.service';
import { ContextService } from 'src/app/shared/services/ctx.service';
import { NavService } from 'src/app/shared/services/nav.service';
import { StateService } from 'src/app/shared/services/state.service';
import { UiService } from 'src/app/shared/services/ui.service';
import { UtilsService } from 'src/app/shared/services/utils.service';
@Component({
  selector: 'app-error-identify-user-modal',
  templateUrl: './error-identify-user-modal.component.html',
  styleUrls: ['./error-identify-user-modal.component.scss'],
})
export class ErrorIdentifyUserModalComponent implements OnInit {
  constructor(
    public dialog: MatDialog,
    private utils: UtilsService,
    private nav: NavService,
    private ctx: ContextService
  ) { }

  ngOnInit(): void {
  }

  openHirePolicy() {
    this.utils.openExternalUrl('https://precio.mapfre.es/calcular-seguro-salud-global');
  }

  openHealthSearch() {
    this.nav.navTo('doctors-centers');
    this.dialog.closeAll();
  }

  openCustomerSupport() {
    const environment = this.ctx.environment;
    let url: string;
    
    switch (environment) {
      case 'pre':
        url = 'https://wmapfre.pre.mapfre.net/area-de-clientes/support';
        break;
      case 'pro':
      case 'pro-buscadores':
        url = 'https://clientes.mapfre.es/area-de-clientes/support';
        break;
      default:
        url = 'https://wmapfre.desa.mapfre.net/area-de-clientes/support';
        break;
    }

    this.utils.openExternalUrl(url);
  }

}
